import React from "react";

const CardList = ({ children }) => (
    <div style={styles.container}>
        {children}
    </div>
);

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
        marginLeft: 'auto',
        marginRight: 'auto',
        alignItems: 'center',
        width: '100%'
    }
};

export default CardList;